/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { ExportsServiceProvider } from './service/ExportsServiceProvider';

// Components
import { exportsBoardComponent } from './component/ExportsBoard';

angular.module('serfimtic.gmao.exports', ['ui.router', 'ngResource'])
.provider('exportsService', ExportsServiceProvider)
.component('exportsBoard', exportsBoardComponent)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.abstractUrlState('gmao.exports', '/exports', ['ADMIN', 'STATS']))
        .state(State.componentState('gmao.exports.board', 'exportsBoard', '/board',
            'ui.exports.board'));
})
.config(exportsServiceProvider => {
    /** @ngInject */
    exportsServiceProvider.setResourceUrl(Configuration.EXPORTS_PATH);
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/exports/ExportsModule.js